const Toaster = {
  NetworkErr: "Comprueba tu conexión a Internet",
  RepeatedBidMsg: "Oferta repetida",
  UniqueBidMsg: "Oferta única",
  DeSelectedBids: "Las ofertas seleccionadas previamente se han deseleccionado",
  NoBidAvailable: "No se pueden seleccionar más ofertas disponibles",
  BidSubmitted:
    "Las ofertas se enviaron correctamente, verifique el estado de su oferta en mi oferta",
  UpdateProfile: "Su perfil se actualizó correctamente",
  UpcomingAuctionMsg: "¡Esta subasta aún no está en vivo!",
  BuyBidsMsg: "No tienes suficientes ofertas",
  "Request failed with status code 500":
    "Solicitud fallida con código de estado 500",
}

const ToasterMsg = {
  network: "Algo salió mal !!",
  repeatedBid: "Oferta repetida.",
  deSelectedBids:
    "Las ofertas seleccionadas previamente se han deseleccionado.",
  noBidAvailable: "No se pueden seleccionar más ofertas disponibles.",
  bidSubmitted: "Ofertas enviadas exitosamente.",
  updateProfile: "Tu perfil se actualizó correctamente.",
  upcomingAuction: "Esta subasta aún no está disponible!!",
  buyBids: "No tienes suficientes ofertas.",
  loginRequired: "Necesario iniciar sesión !!",
}

const HomePage = {
  Bid: "Oferta",
  BidNWin: "BidNWin ESP",
  NoAuction: "No hay subasta disponible",
  Live: "En Vivo",
  Upcoming: "Próximo",
  FreeBidMsg:
    "¡Felicidades! Como usuario por primera vez, ha obtenido <1><0>{{count}}</0> </1> Ofertas gratuitas, Same ha sido agregado en su cuenta",
  OK: "OKAY",
  UserNotFound: "Usuario no encontrado",
  CongratTitle: "oferta por tus productos favoritos a precios increíbles",
  Youhave: "Tienes",
  FreeBids: "Ofertas gratis",
  StartBidding: "Comience a ofertar",
  BuyBids:
    "Ganadores" /*"Comprar ofertas",  changing to winners list for peru as not event based charging */,
  HowBid: "Cómo funciona la oferta",
}

const ProductDetailPage = {
  MyBids: "Mis Ofertas", // My Bids Page
  AuctionNotLive: "¡La subasta aún no está en vivo!",
  BidsRemaining: "Ofertas restantes",
  HowBidWork: "Cómo funciona la oferta",
  KeyFeatures: "Características clave",
  PlaceBid: "Hacer una oferta",
  MarketValue: "Valor de mercado",
}

const PlaceBidPage = {
  ChooseRange: "Seleccionar rango de oferta",
  BidSelected: "se seleccionan las ofertas",
  ConfirmBid: "Confirme su oferta",
  SurePlaceBids: "¿Quieres colocar",
  CannotSelectBid: "No puede seleccionar una oferta superior a",
  No: "No",
  Yes: "Si",
  SelectBid: "Seleccione una o más ofertas",
  SelectBidInfo: "La oferta única más baja ganará",
  PlaceBids: "Realizar Ofertas",
  bids: "Ofertas",
}

const MyBidsPage = {
  All: "Todos",
  UniqueBids: "Ofertas únicas",
  RepeatedBids: "Ofertas repetidas",
  LatestBids: "Últimas ofertas",
  Selected: "seleccionado",
  NoBidsPlaced: "No se hicieron ofertas",
  FirstBidPlaced: "Haga su primera oferta aquí",
  GoodBids: "Good Bids",
  BadBids: "Bad Bids",
  OkBids: "OK Bids",
}

const AccountInfoPage = {
  MyAccount: "Mi cuenta",
  AccountInfo: "Informacion de cuenta",
  PersonalInfo: "Información personal",
  MobileNumber: "Número de teléfono móvil",
  Operator: "Operador",
  Status: "Estado",
  BidsAvailable: "Ofertas disponibles", // Home page
  Bids: "Ofertas",
  SUBSCRIBED: "SUSCRITO",
  UNSUBSCRIBE: "Cancelar suscripción",
  TRIAL: "JUICIO",
  BidsExpiry: "Vencimiento de ofertas",
  BidsExpiryMsg: "las ofertas vencerán hoy",
  BUYBIDS: "COMPRAR OFERTAS",
  UnsubscribeMsg:
    "Estimado usuario, aún le quedan <1><0>{{count}}</0> </1> Ofertas. ¿Está seguro de que desea darse de baja del servicio?",
  UnsubscribeBids: "Dar de baja las ofertas",
  UnsubscribeBtnTxt: "Sí, darse de baja",
  NoPlaceMyBids: "No, haga mis ofertas",
  termsAndConditions: "Términos y Condiciones",
  bidnWinTermAndConditions: "Términos y condiciones BidnWin",
  "Bid n Win Terms And Conditions": "Términos y condiciones BidnWin",
}

const PastWinnersPage = {
  Winners: "Ganadores",
  PastWinners: "Ganadores pasados",
  ListPastAuction: "Lista de subastas pasadas",
  NoWinners: "No hay ganadores todavía",
  WinningBid: "Oferta ganadora", //Winners Detail page
}

const PersonalInfoPage = {
  Profile: "Perfil",
  FullName: "Nombre completo",
  FullNamePlaceHolder: "Ingrese su nombre completo",
  Email: "Identificación de correo",
  EmailPlaceHolder: "Ingrese su dirección de correo electrónico",
  PhoneNumber: "Número de teléfono",
  PhoneNumberPlaceHolder: "Ingrese su número telefónico",
  ShippingAddress: "Dirección de Envío",
  ShippingAddressPlaceHolder: "Ingrese su dirección de envío",
}

const TNC = {
  "LICENSE TO USE": "LICENCIA DE USO 222222",
}

const Menu = {
  Home: "Inicio",
  InviteEarn: "Invita y Gana",
  TNC: "Términos y Condiciones",
  ContactUs: "Contáctenos",
  BID: "Oferta",
  BuyBids: "Comprar ofertas",
  BuyBid: "Comprar ofertas",
  Winners: "Ganadores",
  "My Account": "Mi Cuenta",
}

const Text = {
  Welcome: "Bienvenido a BIDNWIN",
  FreeBids: "Ofertas gratis",
  HeaderMessage: "Oferta y gana productos interesantes",
  HowToBid: "Cómo ofertar",
  Auctions: "Subastas",
  Bid: "Oferta",
  "Place Bid": "Hacer oferta",
  UnlimitedFreeBids: "Ofertas gratis ilimitadas",
  FreeBidsOnRegister:
    "Obtenga una oferta gratuita de S/5 tan pronto como su amigo se registre en BidNWin.",
  ReferalTextMsg:
    "Hola, invite a amigos y familiares a BidNWin y obtenga ofertas gratuitas y gane teléfonos, computadoras portátiles y muchos más clics",
  QuerySuccessfullySubmitted: "Su consulta se envió correctamente",
  NameCantBeEmpty: "El nombre no puede estar vacío",
  InvalidEmailAddress: "Dirección de correo electrónico no válida",
  SelectQueryType: "Seleccione el tipo de consulta",
  MessageCatnBeEmpty: "El mensaje no puede estar vacío",
  Name: "Nombre",
  "Customer Query": "Consulta del cliente",
  Suggestion: "Sugerencia",
  Complaint: "Queja",
  MaxMessageLenDisplay: "Mensaje (255 caracteres permitidos)",
  "Enter your message": "Ingrese su mensaje",
  "Enter your full name": "Ingrese su nombre completo",
  "Enter your email address": "Ingrese su dirección de correo electrónico",
  "Email Address": "Dirección de correo electrónico",
  Submit: "Enviar",
  Type: "Tipo",
  NoMoreSelection: "No puede seleccionar una oferta superior a",
  "Data Saver": "Ahorro de datos",
  step: "epu_step",
  step_file_type: "jpg",
  live_now: "live_now_spanish",
  live_now_file_type: "png",
  MessageCantBeEmpty: "Por favor, rellene este campo.",
}

const newTexts = {
  Testimonials: "Témoignages",
  Logout: "Se déconnecter",
  Edit: "Éditer",
  MyWinnings: "Mes gains",
  DeliveryAddress: "Adresse de livraison",
  Email: "E-mail",
  LiveBids: "Ofertas en vivo",
  ExpiredBids: "Ofertas vencidas",
  Expired: "Caducada",
  AllBidsPlaced: "Todas las ofertas realizadas",
  AllBids: "Todas las ofertas",
  PlaceBids: "Hacer ofertas",
  MyProfile: "Mi perfil",
  EditMyProfile: "Editar mi perfil",
  YouWinner: "Eres la ganadora",
  WinnerName: "Nombre del ganador",
  MultipleBids: "Ofertas múltiples",
  YouBidMore: "Puedes ofertar más de una aquí",
  ChooseBid: "Elegir oferta",
  BidsPlacedSuccessfully: "Pujas realizadas con éxito",
  UserBidSummary: "Resumen de la oferta del usuario",
  ListOfBids:
    "Lista de ofertas únicas y no únicas realizadas con categorización de colores",
  GreenIs: "verde es",
  OrangeIs: "rojo es",
  Unique: "Única",
  RedIs: "rojo es",
  NonUnique: "No única",
  PlaceMoreBids: "Hacer más ofertas",
  PlaceBidsBetween: "Hacer ofertas entre",
  And: "y",
  ImproveWinningChances: "para mejorar sus posibilidades de ganar",
  SkipToHome: "Saltar a Inicio",
  ColourLegends: "Leyendas de colores",
  SeeAll: "Ver todo",
  TrendingBids: "Ofertas de tendencia",
  DailyBids: "Ofertas diarias",
  WeeklyBids: "Ofertas semanales",
  Days: "Días",
  Day: "Día",
  KeyFeatures: "Características clave",
  AuctionNotLiveYet: "La subasta aún no está activa",
  BidBalance: "Saldo de la oferta",
  ExpiredBidCount: "Recuento de ofertas vencidas",
  Good: "Buena",
  Okay: "De acuerdo",
  Bad: "Mala",
}

const es = {
  translations: {
    ...HomePage,
    ...MyBidsPage,
    ...ProductDetailPage,
    ...PlaceBidPage,
    ...AccountInfoPage,
    ...PastWinnersPage,
    ...PersonalInfoPage,
    ...Toaster,
    ...TNC,
    ...Menu,
    ...Text,
    ...ToasterMsg,
    ...newTexts,
  },
}

export default es



// WEBPACK FOOTER //
// ./src/languages/es.js